import { memo } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import colors from 'utils/colors'
import { icons } from 'utils/icons'
import { MESSAGES } from 'locales/locales'

import CustomIcon from 'components/icon/CustomIcon'
import CustomText from 'components/text/CustomText'

export interface IJumperProps {
  onClose: () => void
  onScrollBottom: () => void
  counter: number
  sidePanel?: boolean
}

const Jumper = ({ onClose, onScrollBottom, counter, sidePanel = false }: IJumperProps) => {
  const { t } = useTranslation()
  return (
    <Wrapper sidePanel={sidePanel}>
      <TextContainer>
        <CustomText typography="body4" color={colors.white} onClick={onScrollBottom}>
          {counter + ' ' + t(MESSAGES.NEW_MESSAGES) + ' -'}
        </CustomText>
        <CustomText typography="body3" color={colors.white} marginLeft={3} onClick={onScrollBottom}>
          {t(MESSAGES.JUMP_NEW_MESSAGES)}
        </CustomText>
      </TextContainer>
      <IconWrapper>
      <CustomIcon source={icons.closeIconWhite} onClick={onClose} />
      </IconWrapper>
    </Wrapper>
  )
}

export default memo(Jumper)

export const Wrapper = styled.div<{ sidePanel?: boolean }>`
  cursor: pointer;
  /* top: 80px; */
  display: flex;
  position: absolute;
  bottom: 110px;
  left: 0px;
  right: ${({ sidePanel }) => sidePanel ? '430px' : '0px'};
  margin: 0px 20px;
  background-color: ${colors.vime};
  align-items: center;
  padding: 0px 2px 2px 6px;
  border-radius: 4px;
  z-index: 3;
`
export const IconWrapper = styled.div`
  display: flex;
  margin-left: auto;
  padding-left: 10px;
`

export const TextContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;